export const SkillsData = [
  {
    type: "Frontend Development",
    list: [
      {
        name: "React.js",
        icon: <i className="devicon-react-original colored"></i>,
      },
      {
        name: "Next.js",
        icon: <i className="devicon-nextjs-original-wordmark colored"></i>,
      },
      {
        name: "JavaScript (ES6+)",
        icon: <i className="devicon-javascript-plain colored"></i>,
      },
      {
        name: "TypeScript",
        icon: <i className="devicon-typescript-plain colored"></i>,
      },
      {
        name: "Redux Toolkit",
        icon: <i className="devicon-redux-original colored"></i>,
      },
      {
        name: "Tailwind CSS",
        icon: <i className="devicon-tailwindcss-original-wordmark colored"></i>,
      },
      {
        name: "HTML5",
        icon: <i className="devicon-html5-plain colored"></i>,
      },
      {
        name: "CSS3",
        icon: <i className="devicon-css3-plain colored"></i>,
      },
    ],
  },
  {
    type: "Backend Development",
    list: [
      {
        name: "Node.js",
        icon: <i className="devicon-nodejs-plain-wordmark colored"></i>,
      },
      {
        name: "Express.js",
        icon: <i className="devicon-express-original-wordmark colored"></i>,
      },
      {
        name: "Python",
        icon: <i className="devicon-python-plain colored"></i>,
      },
      {
        name: "FastAPI",
        icon: <i className="devicon-fastapi-plain colored"></i>,
      },
    ],
  },
  {
    type: "AI & LLM Engineering",
    list: [
      {
        name: "LLM APIs",
        icon: <i className="fi fi-rr-brain"></i>,
      },
      {
        name: "AI Agents",
        icon: <i className="fi fi-rr-brain-circuit"></i>,
      },
      {
        name: "RAG",
        icon: <i className="fi fi-rr-database"></i>,
      },
      {
        name: "Prompt Engineering",
        icon: <i className="fi fi-rr-comment"></i>,
      },
    ],
  },
  {
    type: "Database & Testing",
    list: [
      {
        name: "PostgreSQL",
        icon: <i className="devicon-postgresql-plain colored"></i>,
      },
      {
        name: "Jest",
        icon: <i className="devicon-jest-plain colored"></i>,
      },
      {
        name: "Cypress",
        icon: <i className="fi fi-rr-bug"></i>,
      },
    ],
  },
  {
    type: "Cloud & DevOps",
    list: [
      {
        name: "AWS",
        icon: (
          <i className="devicon-amazonwebservices-plain-wordmark colored"></i>
        ),
      },
      {
        name: "GCP",
        icon: <i className="devicon-googlecloud-plain colored"></i>,
      },
      {
        name: "Docker",
        icon: <i className="devicon-docker-plain colored"></i>,
      },
      {
        name: "CI/CD",
        icon: <i className="fi fi-rr-arrows-repeat"></i>,
      },
      {
        name: "Git",
        icon: <i className="devicon-git-plain-wordmark colored"></i>,
      },
    ],
  },
];
